import React, { useEffect, useState } from "react"
import { Carousel, CarouselItem } from "reactstrap"
import { isMobile } from "react-device-detect"

const imgAdobeLogo = require("../../../static/img/adobe.png")
const imgTrueCallerLogo = require("../../../static/img/truecaller.png")
const imgDataCaptiveLogo = require("../../../static/img/datacaptive.png")
const imgInMobiLogo = require("../../../static/img/inmobi.png")
const imgChargebee = require("../../../static/img/chargebee.png")

const logos = [
  { src: imgAdobeLogo, alt: 'Adobe', width: isMobile ? 130 : 150, height: 30 },
  { src: imgTrueCallerLogo, alt: 'Truecaller', width: isMobile ? 130 : 150, height: 35 },
  { src: imgChargebee, alt: 'Chargebee', width: isMobile ? 130 : 150, height: 35 },
  { src: imgDataCaptiveLogo, alt: 'DataCaptive', width: isMobile ? 130 : 150, height: 35 },
  { src: imgInMobiLogo, alt: 'InMobi', width: 120, height: 25 }
]

const DisplayLogos = () => {

  const [activeIndex, setActiveIndex] = useState(0)
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth
  })

  useEffect(
    () => {
      window.addEventListener("resize", handleResize)

      return () => {
        window.removeEventListener("resize", handleResize)
      }
    },
    []
  )

  const handleResize = () => {
    setDimensions({
      width: window.innerWidth
    })
    setActiveIndex(0)
  }

  const slides = logos.reduce((acc, element, index) => {
    const groupSize = dimensions.width < 960 ? 2 : dimensions.width < 1100 ? 3 : 6
    const slideIndex = Math.floor(index / groupSize)
    if (!acc[slideIndex]) {
      acc[slideIndex] = [];
    }
    acc[slideIndex].push(element);
    return acc;
  }, [])

  const next = () => {
    const nextIndex = activeIndex === slides.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    const nextIndex = activeIndex === 0 ? slides.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex)
  }

  const renderSlides = () => {
    return slides.map((slide, index) => (
      <CarouselItem key={index}>
        <div className='carousel-logo-wrapper'>
          {slide.map((element, innerIndex) => (
            <div key={innerIndex} className="logo">
              <img src={element.src} alt={element.alt} width={element.width} height={element.height} />
            </div>
          ))}
        </div>
      </CarouselItem>
    ));
  };


  return (
    <Carousel
      interval={3000}
      ride="carousel"
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      keyboard={false}
    >
      {renderSlides()}
    </Carousel>
  )
}
export default DisplayLogos